import Seo from '../components/Seo';

export default function TermsAndConditions() {
  const terms = [
    {
      title: 'License Share Code',
      content:
        'You (the student) must send your license share code before lessons can begin.'
    },
    {
      title: 'Payment Timing',
      content: 'Lesson payments must be made in advance, at least 72 hours before the lesson.'
    },
    {
      title: 'Cancellation Policy',
      content:
        'Cancellations must be made at least 48 hours in advance. Late cancellations are charged at the full lesson price.'
    },
    {
      title: 'Test Readiness',
      content:
        'You must be fully test ready before taking your practical test. If I (the instructor) believe additional training is needed, this must be agreed. If you choose to proceed without this, I will not be able to take you to test.'
    },
    {
      title: 'Ready to Pass Requirement',
      content: 'You must complete the Ready to Pass check before taking your practical test.'
    },
    {
      title: 'Traffic Fines During Lessons',
      content:
        'Any penalty charges received during a lesson (for example speeding or bus lane offences) are fully payable by the driver (you).'
    },
    {
      title: 'Drugs and Alcohol',
      content:
        'No drugs or alcohol should be consumed within 24 hours of a lesson. If this rule is broken, the lesson is cancelled and fully charged.'
    },
    {
      title: 'Dual Controls and Safety Intervention',
      content:
        'The car is fitted with dual controls. If needed, I may take control using the brake and/or steering wheel. We will then pull over and discuss the incident.'
    },
    {
      title: 'What You Must Bring',
      content:
        'You must bring your photocard provisional licence, wear suitable driving footwear, and wear glasses if you need them for driving.'
    },
    {
      title: 'First Lesson Procedure',
      content:
        'At first, I will drive to a quieter area and drive back to the drop-off location at the end of the lesson. This helps you get familiar with the car. We continue this approach until you can drive safely on main roads.'
    },
    {
      title: 'Agreement Confirmation',
      content: 'Please confirm acceptance of these Terms and Conditions by text message or email.'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16 px-4">
      <Seo
        title="Terms and Conditions | Bezy Driving School"
        description="Terms and conditions for driving lessons with Bezy Driving School, including payments, cancellations, test readiness, and learner responsibilities."
        path="/terms-and-conditions"
      />
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Terms and Conditions
          </h1>
          <p className="text-lg text-gray-600">
            Please read these terms carefully before starting lessons.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-10 space-y-8">
          <p className="text-gray-700 leading-relaxed">
            According to the DVSA, on average it takes a student 42 hours with a qualified instructor plus
            20 hours with a family member to be test ready. Some learners will need more hours, depending on
            their pace of learning.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="rounded-xl border border-amber-300 bg-amber-50 p-4">
              <p className="text-sm font-semibold text-amber-900">Payment Notice</p>
              <p className="text-gray-700 mt-1">All lesson payments are due at least 72 hours in advance.</p>
            </div>
            <div className="rounded-xl border border-rose-300 bg-rose-50 p-4">
              <p className="text-sm font-semibold text-rose-900">Cancellation Notice</p>
              <p className="text-gray-700 mt-1">A minimum of 48 hours notice is required to cancel.</p>
            </div>
          </div>

          <ol className="text-gray-700 space-y-5 leading-relaxed">
            {terms.map((term, index) => (
              <li key={term.title} className="rounded-xl border border-gray-200 p-5 bg-gray-50">
                <p className="font-bold text-gray-900 mb-1">
                  {index + 1}. {term.title}
                </p>
                <p>{term.content}</p>

                {term.title === 'Ready to Pass Requirement' && (
                  <p className="mt-2">
                    Government link:{' '}
                    <a
                      href="https://readytopass.campaign.gov.uk/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 font-semibold"
                    >
                      https://readytopass.campaign.gov.uk/
                    </a>
                  </p>
                )}

                {term.title === 'License Share Code' && (
                  <p className="mt-2">
                    Government link:{' '}
                    <a
                      href="https://www.gov.uk/view-driving-licence"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 font-semibold"
                    >
                      https://www.gov.uk/view-driving-licence
                    </a>
                  </p>
                )}
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}
